import type { GetUserPaymentMethodsResponse } from '@fourthwall/services/dist/PaymentApiClient'
import { formatExpiresAt } from '@modules/Dashboard/modules/PaymentMethods/utils/formatExpiresAt'

export const mapUserPaymentMethods = (paymentMethods: GetUserPaymentMethodsResponse) =>
  paymentMethods.map((paymentMethod, index) => {
    if (paymentMethod.details.type === 'CARD') {
      return {
        id: paymentMethod.id,
        type: 'CARD' as const,
        brand: paymentMethod.details.brand,
        number: paymentMethod.details.last4Digits,
        expires: formatExpiresAt(paymentMethod.details.expiresAt),
        selected: index === 0,
      }
    }

    // PAYPAL
    return {
      id: paymentMethod.id,
      type: 'PAYPAL' as const,
      email: paymentMethod.details.email,
      selected: index === 0,
    }
  })
